var forms = document.querySelectorAll("form");

// listeners

forms.forEach(form => {


    if(form.querySelectorAll("[required]")){
        form.classList.add("missing-required-values")
    }

	form.addEventListener("input", function(e) {

		flagAsCompleted(e, form);

		// add form class
		function flagAsCompleted(e, form, className) {

			if (!className) className = "missing-required-values";

			if (!isReqValuesFilled(form)) {
				form.classList.add(className);
			} else {
				form.classList.remove(className);
			}
		}

		// check fields have values
		function isReqValuesFilled(form) {

			var fields = form.querySelectorAll("[required]");

			// bail if no required input
			if (!fields) return;

			// get all inputs and values
			var blanks = [...fields].filter(field => {
				return !field.value;
			});

			return blanks.length == 0 ? true : false;
		}
	});
});


